
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M22.2499 14.29L21.5599 16.18L9.1999 11.71L10.5899 7.91999C10.9699 6.88999 12.1099 6.35999 13.1499 6.72999L19.8399 9.13999C21.9399 9.89999 23.0199 12.2 22.2499 14.29ZM2.4499 12.48L7.9999 14.48V18C7.9999 18.55 8.4499 19 8.9999 19H14.9999C15.5499 19 15.9999 18.55 15.9999 18V17.37L19.5799 18.66C20.0999 18.85 20.6799 18.58 20.8699 18.06C21.0599 17.54 20.7899 16.96 20.2699 16.77L3.1299 10.59C2.6099 10.4 2.0299 10.67 1.8399 11.19C1.6599 11.71 1.9299 12.29 2.4499 12.48ZM7.2999 10.2C8.7899 9.47999 9.4199 7.68999 8.7099 6.19999C7.9899 4.70999 6.1999 4.07999 4.6999 4.79999C3.2099 5.50999 2.5799 7.29999 3.2999 8.79999C4.0099 10.29 5.7999 10.92 7.2999 10.2Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-airline-seat-flat-angled`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconAirlineSeatFlatAngled

    ```js
    <b-new-b-icon-airline-seat-flat-angled />
    ```
</docs>


